import * as $runtime from "../runtime.js";
import * as Codec$dJSON$dDecodeError from "../Codec.JSON.DecodeError/index.js";
import * as Control$dMonad$dExcept$dTrans from "../Control.Monad.Except.Trans/index.js";
import * as Data$dArray from "../Data.Array/index.js";
import * as Data$dCodec from "../Data.Codec/index.js";
import * as Data$dEither from "../Data.Either/index.js";
import * as Data$dFunctor from "../Data.Functor/index.js";
import * as Data$dIdentity from "../Data.Identity/index.js";
import * as Data$dInt from "../Data.Int/index.js";
import * as Data$dList$dTypes from "../Data.List.Types/index.js";
import * as Data$dMaybe from "../Data.Maybe/index.js";
import * as Data$dString$dCodePoints from "../Data.String.CodePoints/index.js";
import * as Data$dString$dCodeUnits from "../Data.String.CodeUnits/index.js";
import * as Data$dTraversableWithIndex from "../Data.TraversableWithIndex/index.js";
import * as Data$dTuple from "../Data.Tuple/index.js";
import * as $$JSON from "../JSON/index.js";
import * as JSON$dInternal from "../JSON.Internal/index.js";
import * as JSON$dPath from "../JSON.Path/index.js";
import * as Record$dUnsafe from "../Record.Unsafe/index.js";
import * as Type$dProxy from "../Type.Proxy/index.js";
const applicativeExceptT = /* #__PURE__ */ Control$dMonad$dExcept$dTrans.applicativeExceptT(Data$dIdentity.monadIdentity);
const bindExceptT = /* #__PURE__ */ Control$dMonad$dExcept$dTrans.bindExceptT(Data$dIdentity.monadIdentity);
const traverseWithIndex = /* #__PURE__ */ (() => Data$dTraversableWithIndex.traversableWithIndexArray.traverseWithIndex(applicativeExceptT))();
const record = /* #__PURE__ */ (() => Data$dCodec.$Codec(
  (() => {
    const $0 = applicativeExceptT.pure({});
    return v => $0;
  })(),
  Data$dTuple.applicativeTuple(Data$dList$dTypes.monoidList).pure
))();
const $$null = /* #__PURE__ */ Data$dCodec.$Codec(
  j => {
    const v = JSON$dInternal._case(Data$dMaybe.Just, $$JSON.fail, $$JSON.fail, $$JSON.fail, $$JSON.fail, $$JSON.fail, j);
    if (v.tag === "Just") { return Data$dEither.$Either("Right", v._1); }
    if (v.tag === "Nothing") { return Data$dEither.$Either("Left", {path: JSON$dPath.Tip, message: "Expected value of type Null", causes: []}); }
    $runtime.fail();
  },
  b => Data$dTuple.$Tuple($$JSON._null, b)
);
const number = /* #__PURE__ */ Data$dCodec.$Codec(
  j => {
    const v = JSON$dInternal._case($$JSON.fail, $$JSON.fail, Data$dMaybe.Just, $$JSON.fail, $$JSON.fail, $$JSON.fail, j);
    if (v.tag === "Just") { return Data$dEither.$Either("Right", v._1); }
    if (v.tag === "Nothing") { return Data$dEither.$Either("Left", {path: JSON$dPath.Tip, message: "Expected value of type Number", causes: []}); }
    $runtime.fail();
  },
  b => Data$dTuple.$Tuple(JSON$dInternal._fromNumberWithDefault(0, b), b)
);
const string = /* #__PURE__ */ Data$dCodec.$Codec(
  j => {
    const v = JSON$dInternal._case($$JSON.fail, $$JSON.fail, $$JSON.fail, Data$dMaybe.Just, $$JSON.fail, $$JSON.fail, j);
    if (v.tag === "Just") { return Data$dEither.$Either("Right", v._1); }
    if (v.tag === "Nothing") { return Data$dEither.$Either("Left", {path: JSON$dPath.Tip, message: "Expected value of type String", causes: []}); }
    $runtime.fail();
  },
  b => Data$dTuple.$Tuple($$JSON.fromString(b), b)
);
const $$void = /* #__PURE__ */ Data$dCodec.$Codec(
  j => Data$dEither.$Either("Left", {path: JSON$dPath.Tip, message: "Expected value of type Void", causes: []}),
  b => Data$dTuple.$Tuple(
    (() => {
      const spin = spin$a0$copy => {
        let spin$a0 = spin$a0$copy, spin$c = true, spin$r;
        while (spin$c) {
          const v = spin$a0;
          spin$a0 = v;
        }
        return spin$r;
      };
      return spin(b);
    })(),
    b
  )
);
const json = /* #__PURE__ */ (() => Data$dCodec.$Codec(applicativeExceptT.pure, b => Data$dTuple.$Tuple(b, b)))();
const jobject = /* #__PURE__ */ Data$dCodec.$Codec(
  j => {
    const v = JSON$dInternal._case($$JSON.fail, $$JSON.fail, $$JSON.fail, $$JSON.fail, $$JSON.fail, Data$dMaybe.Just, j);
    if (v.tag === "Just") { return Data$dEither.$Either("Right", v._1); }
    if (v.tag === "Nothing") { return Data$dEither.$Either("Left", {path: JSON$dPath.Tip, message: "Expected value of type Object", causes: []}); }
    $runtime.fail();
  },
  b => Data$dTuple.$Tuple($$JSON.fromJObject(b), b)
);
const jarray = /* #__PURE__ */ Data$dCodec.$Codec(
  j => {
    const v = JSON$dInternal._case($$JSON.fail, $$JSON.fail, $$JSON.fail, $$JSON.fail, Data$dMaybe.Just, $$JSON.fail, j);
    if (v.tag === "Just") { return Data$dEither.$Either("Right", v._1); }
    if (v.tag === "Nothing") { return Data$dEither.$Either("Left", {path: JSON$dPath.Tip, message: "Expected value of type Array", causes: []}); }
    $runtime.fail();
  },
  b => Data$dTuple.$Tuple($$JSON.fromJArray(b), b)
);
const $$int = /* #__PURE__ */ Data$dCodec.$Codec(
  j => {
    const $0 = JSON$dInternal._case($$JSON.fail, $$JSON.fail, Data$dMaybe.Just, $$JSON.fail, $$JSON.fail, $$JSON.fail, j);
    const v = (() => {
      if ($0.tag === "Just") { return Data$dInt.fromNumber($0._1); }
      if ($0.tag === "Nothing") { return Data$dMaybe.Nothing; }
      $runtime.fail();
    })();
    if (v.tag === "Just") { return Data$dEither.$Either("Right", v._1); }
    if (v.tag === "Nothing") { return Data$dEither.$Either("Left", {path: JSON$dPath.Tip, message: "Expected value of type Int", causes: []}); }
    $runtime.fail();
  },
  b => Data$dTuple.$Tuple(JSON$dInternal._fromNumberWithDefault(0, Data$dInt.toNumber(b)), b)
);
const encode = Data$dCodec.encode;
const indexedArray = codec => Data$dCodec.$Codec(
  j => bindExceptT.bind(jarray._1(j))(codec._1),
  b => Data$dTuple.$Tuple(jarray._2(JSON$dInternal.fromArray(Data$dArray.fromFoldableImpl(Data$dList$dTypes.foldableList.foldr, codec._2(b)._1)))._1, b)
);
const object = codec => Data$dCodec.$Codec(
  j => bindExceptT.bind(jobject._1(j))(codec._1),
  b => Data$dTuple.$Tuple(
    jobject._2(JSON$dInternal._fromEntries(Data$dTuple.fst, Data$dTuple.snd, Data$dArray.fromFoldableImpl(Data$dList$dTypes.foldableList.foldr, codec._2(b)._1)))._1,
    b
  )
);
const decode = codec => j => codec._1(j);
const index = ix => codec => Data$dCodec.$Codec(
  xs => {
    const v = JSON$dInternal._index(Data$dMaybe.Nothing, Data$dMaybe.Just, ix, xs);
    if (v.tag === "Just") {
      const v1 = codec._1(v._1);
      if (v1.tag === "Left") { return Data$dEither.$Either("Left", Codec$dJSON$dDecodeError.withPath(JSON$dPath.AtIndex(ix))(v1._1)); }
      return v1;
    }
    if (v.tag === "Nothing") { return Data$dEither.$Either("Left", {path: JSON$dPath.$Path("AtIndex", ix, JSON$dPath.Tip), message: "No value found", causes: []}); }
    $runtime.fail();
  },
  b => Data$dTuple.$Tuple(Data$dList$dTypes.$List("Cons", codec._2(b)._1, Data$dList$dTypes.Nil), b)
);
const named = name => codec => Data$dCodec.$Codec(
  j => {
    const v = codec._1(j);
    if (v.tag === "Left") { return Data$dEither.$Either("Left", {path: v._1.path, message: "Could not decode " + name, causes: [v._1]}); }
    return v;
  },
  b => Data$dTuple.$Tuple(codec._2(b)._1, b)
);
const nullable = codec => Data$dCodec.$Codec(
  j => {
    const v = codec._1(j);
    if (v.tag === "Left") {
      const v1 = $$null._1(j);
      if (v1.tag === "Left") { return Data$dEither.$Either("Left", Codec$dJSON$dDecodeError.semigroupDecodeError.append(v._1)(v1._1)); }
      if (v1.tag === "Right") { return Data$dEither.$Either("Right", Data$dMaybe.Nothing); }
      $runtime.fail();
    }
    if (v.tag === "Right") { return Data$dEither.$Either("Right", Data$dMaybe.$Maybe("Just", v._1)); }
    $runtime.fail();
  },
  b => Data$dTuple.$Tuple(
    (() => {
      if (b.tag === "Just") { return codec._2(b._1)._1; }
      if (b.tag === "Nothing") { return $$JSON._null; }
      $runtime.fail();
    })(),
    b
  )
);
const prismaticCodec = name => f => g => codec => Data$dCodec.$Codec(
  j => {
    const v = codec._1(j);
    if (v.tag === "Left") { return Data$dEither.$Either("Left", {path: v._1.path, message: "Could not decode " + name, causes: [v._1]}); }
    if (v.tag === "Right") {
      const v1 = f(v._1);
      if (v1.tag === "Just") { return Data$dEither.$Either("Right", v1._1); }
      if (v1.tag === "Nothing") { return Data$dEither.$Either("Left", {path: JSON$dPath.Tip, message: "Could not decode " + name + ", unexpected value found", causes: []}); }
    }
    $runtime.fail();
  },
  b => Data$dTuple.$Tuple(codec._2(g(b))._1, b)
);
const prop = key => codec => Data$dCodec.$Codec(
  obj => {
    const v = JSON$dInternal._lookup(Data$dMaybe.Nothing, Data$dMaybe.Just, key, obj);
    if (v.tag === "Just") {
      const v1 = codec._1(v._1);
      if (v1.tag === "Left") { return Data$dEither.$Either("Left", Codec$dJSON$dDecodeError.withPath(JSON$dPath.AtKey(key))(v1._1)); }
      return v1;
    }
    if (v.tag === "Nothing") { return Data$dEither.$Either("Left", {path: JSON$dPath.$Path("AtKey", key, JSON$dPath.Tip), message: "No value found", causes: []}); }
    $runtime.fail();
  },
  b => Data$dTuple.$Tuple(Data$dList$dTypes.$List("Cons", Data$dTuple.$Tuple(key, codec._2(b)._1), Data$dList$dTypes.Nil), b)
);
const recordProp = dictIsSymbol => () => codecA => codecR => {
  const key = dictIsSymbol.reflectSymbol(Type$dProxy.Proxy);
  return Data$dCodec.$Codec(
    obj => bindExceptT.bind(codecR._1(obj))(r => bindExceptT.bind((() => {
      const v = JSON$dInternal._lookup(Data$dMaybe.Nothing, Data$dMaybe.Just, key, obj);
      if (v.tag === "Just") {
        const v1 = codecA._1(v._1);
        if (v1.tag === "Left") { return Data$dEither.$Either("Left", Codec$dJSON$dDecodeError.withPath(JSON$dPath.AtKey(key))(v1._1)); }
        return v1;
      }
      if (v.tag === "Nothing") { return Data$dEither.$Either("Left", {path: JSON$dPath.$Path("AtKey", key, JSON$dPath.Tip), message: "No value found", causes: []}); }
      $runtime.fail();
    })())(a => applicativeExceptT.pure(Record$dUnsafe.unsafeSet(key)(a)(r)))),
    b => Data$dTuple.$Tuple(Data$dList$dTypes.$List("Cons", Data$dTuple.$Tuple(key, codecA._2(Record$dUnsafe.unsafeGet(key)(b))._1), codecR._2(b)._1), b)
  );
};
const recordPropOptional = dictIsSymbol => () => codecA => codecR => {
  const key = dictIsSymbol.reflectSymbol(Type$dProxy.Proxy);
  return Data$dCodec.$Codec(
    obj => bindExceptT.bind(codecR._1(obj))(r => bindExceptT.bind((() => {
      const v = JSON$dInternal._lookup(Data$dMaybe.Nothing, Data$dMaybe.Just, key, obj);
      if (v.tag === "Just") {
        const v1 = codecA._1(v._1);
        if (v1.tag === "Left") { return Data$dEither.$Either("Left", Codec$dJSON$dDecodeError.withPath(JSON$dPath.AtKey(key))(v1._1)); }
        if (v1.tag === "Left") { return Data$dEither.$Either("Left", v1._1); }
        if (v1.tag === "Right") { return Data$dEither.$Either("Right", Data$dMaybe.$Maybe("Just", v1._1)); }
        $runtime.fail();
      }
      return Data$dEither.$Either("Right", Data$dMaybe.Nothing);
    })())(a => applicativeExceptT.pure(Record$dUnsafe.unsafeSet(key)(a)(r)))),
    b => Data$dTuple.$Tuple(
      (() => {
        const w = codecR._2(b)._1;
        const v = Record$dUnsafe.unsafeGet(key)(b);
        if (v.tag === "Just") { return Data$dList$dTypes.$List("Cons", Data$dTuple.$Tuple(key, codecA._2(v._1)._1), w); }
        if (v.tag === "Nothing") { return w; }
        $runtime.fail();
      })(),
      b
    )
  );
};
const coercible = () => name => codec => Data$dCodec.$Codec(
  j => {
    const v = codec._1(j);
    if (v.tag === "Left") { return Data$dEither.$Either("Left", {path: v._1.path, message: "Could not decode " + name, causes: [v._1]}); }
    return v;
  },
  b => Data$dTuple.$Tuple(codec._2(b)._1, b)
);
const codePoint = /* #__PURE__ */ Data$dCodec.$Codec(
  j => {
    const $0 = JSON$dInternal._case($$JSON.fail, $$JSON.fail, $$JSON.fail, Data$dMaybe.Just, $$JSON.fail, $$JSON.fail, j);
    const v = (() => {
      if ($0.tag === "Just") { return Data$dString$dCodePoints.codePointAt(0)($0._1); }
      if ($0.tag === "Nothing") { return Data$dMaybe.Nothing; }
      $runtime.fail();
    })();
    if (v.tag === "Just") { return Data$dEither.$Either("Right", v._1); }
    if (v.tag === "Nothing") { return Data$dEither.$Either("Left", {path: JSON$dPath.Tip, message: "Expected value of type CodePoint", causes: []}); }
    $runtime.fail();
  },
  b => Data$dTuple.$Tuple($$JSON.fromString(Data$dString$dCodePoints.singleton(b)), b)
);
const $$char = /* #__PURE__ */ Data$dCodec.$Codec(
  j => {
    const $0 = JSON$dInternal._case($$JSON.fail, $$JSON.fail, $$JSON.fail, Data$dMaybe.Just, $$JSON.fail, $$JSON.fail, j);
    const v = (() => {
      if ($0.tag === "Just") { return Data$dString$dCodeUnits.toChar($0._1); }
      if ($0.tag === "Nothing") { return Data$dMaybe.Nothing; }
      $runtime.fail();
    })();
    if (v.tag === "Just") { return Data$dEither.$Either("Right", v._1); }
    if (v.tag === "Nothing") { return Data$dEither.$Either("Left", {path: JSON$dPath.Tip, message: "Expected value of type Char", causes: []}); }
    $runtime.fail();
  },
  b => Data$dTuple.$Tuple($$JSON.fromString(Data$dString$dCodeUnits.singleton(b)), b)
);
const $$boolean = /* #__PURE__ */ Data$dCodec.$Codec(
  j => {
    const v = JSON$dInternal._case($$JSON.fail, Data$dMaybe.Just, $$JSON.fail, $$JSON.fail, $$JSON.fail, $$JSON.fail, j);
    if (v.tag === "Just") { return Data$dEither.$Either("Right", v._1); }
    if (v.tag === "Nothing") { return Data$dEither.$Either("Left", {path: JSON$dPath.Tip, message: "Expected value of type Boolean", causes: []}); }
    $runtime.fail();
  },
  b => Data$dTuple.$Tuple($$JSON.fromBoolean(b), b)
);
const array = codec => Data$dCodec.$Codec(
  j => bindExceptT.bind(jarray._1(j))(arr => traverseWithIndex(ix => a => {
    const v = codec._1(a);
    if (v.tag === "Left") { return Data$dEither.$Either("Left", Codec$dJSON$dDecodeError.withPath(JSON$dPath.AtIndex(ix))(v._1)); }
    return v;
  })(JSON$dInternal.toArray(arr))),
  b => Data$dTuple.$Tuple($$JSON.fromJArray(JSON$dInternal.fromArray(Data$dFunctor.arrayMap(x => codec._2(x)._1)(b))), b)
);
export {
  applicativeExceptT,
  array,
  bindExceptT,
  $$boolean as boolean,
  $$char as char,
  codePoint,
  coercible,
  decode,
  encode,
  index,
  indexedArray,
  $$int as int,
  jarray,
  jobject,
  json,
  named,
  $$null as null,
  nullable,
  number,
  object,
  prismaticCodec,
  prop,
  record,
  recordProp,
  recordPropOptional,
  string,
  traverseWithIndex,
  $$void as void
};
